<template>
  <div class="item any-fn">
    <SwiperBox :tabs="list" :options="options">
      <div v-for="item in list" :key="item.id" class="swiper-slide">
        <img v-lazy="item.img_url" />
      </div>
    </SwiperBox>
  </div>
</template>

<script>
import SwiperBox from '../common/SwiperBox'
export default {
  components: {
    SwiperBox
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      options: {
        mode: 'vertical'
      }
    }
  }
}
</script>
